function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import Select from "react-select";
import "../../poliza.scss";
import { CurrencyTypes } from "../../../../utils/data";
import { formatValue, getSeparatorByCurrency, formatDecimal } from "../../../../utils/currency";
import CurrencyInput from "../../../../helperComponents/CurrencyInput/CurrencyInput";

var BrokerInformation = function BrokerInformation(props) {
  var _poliza$broker_inform;

  var poliza = props.poliza,
      onChange = props.onChange,
      _props$insuranceBroke = props.insuranceBrokerAgents,
      insuranceBrokerAgents = _props$insuranceBroke === void 0 ? [] : _props$insuranceBroke;
  var agentOptions = insuranceBrokerAgents.map(function (agent) {
    return {
      value: agent.id,
      label: "".concat(agent.full_name || "", " ").concat(agent.rut || "").trim() || "ID ".concat(agent.id)
    };
  });
  var executiveId = (_poliza$broker_inform = poliza.broker_information) === null || _poliza$broker_inform === void 0 ? void 0 : _poliza$broker_inform.insurance_broker_executive_id;
  var selectedAgent = executiveId != null ? agentOptions.find(function (o) {
    return o.value === executiveId;
  }) : null;

  var onChangeItem = function onChangeItem(newItem) {
    var new_data = _objectSpread(_objectSpread({}, poliza.broker_information), newItem);

    var broker_commission = new_data.affects_net_bonus * (new_data.commission_affect / 100) + new_data.exempt_net_bonus * (new_data.commission_exempt / 100);
    var agent_commission = (new_data.affects_net_bonus * (new_data.commission_affect / 100) + new_data.exempt_net_bonus * (new_data.commission_exempt / 100)) * (new_data.commission_percentage / 100);

    var broker_information = _objectSpread(_objectSpread({}, new_data), {}, {
      broker_commission: formatDecimal(broker_commission, currencyFormat.decimalLimit),
      agent_commission: formatDecimal(agent_commission, currencyFormat.decimalLimit)
    });

    onChange(_objectSpread(_objectSpread({}, poliza), {}, {
      broker_information: broker_information
    }));
  };

  var currencyFormat = getSeparatorByCurrency(poliza.currency);
  var decimalFormat = getSeparatorByCurrency(CurrencyTypes.PERCENTAGE);
  return /*#__PURE__*/React.createElement("div", {
    className: "cntBrokerInformation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card cntCorredor"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/React.createElement("strong", null, "Corredor")), /*#__PURE__*/React.createElement("div", {
    className: "card-body row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Porcentaje Comisi\xF3n Afecta"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    currency: CurrencyTypes.PERCENTAGE,
    defaultValue: poliza.broker_information.commission_affect,
    onValueChange: function onValueChange(value) {
      return onChangeItem({
        commission_affect: formatValue(value, decimalFormat.decimalLimit)
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Porcentaje Comisi\xF3n Exenta"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    currency: CurrencyTypes.PERCENTAGE,
    defaultValue: poliza.broker_information.commission_exempt,
    onValueChange: function onValueChange(value) {
      return onChangeItem({
        commission_exempt: formatValue(value, decimalFormat.decimalLimit)
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Comisi\xF3n Corredor"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    currency: currencyFormat.currency,
    value: poliza.broker_information.broker_commission,
    disabled: true
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card cntAgente"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/React.createElement("strong", null, "Agente")), /*#__PURE__*/React.createElement("div", {
    className: "card-body row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nombre - RUT Agente"), /*#__PURE__*/React.createElement(Select, {
    options: agentOptions,
    value: selectedAgent,
    isClearable: true,
    isSearchable: true,
    placeholder: "Selecciona Agente...",
    onChange: function onChange(option) {
      var agent = option ? insuranceBrokerAgents.find(function (a) {
        return a.id === option.value;
      }) : null;
      onChangeItem({
        insurance_broker_executive_id: option ? option.value : null,
        insurance_broker_executive: agent ? {
          id: agent.id,
          full_name: agent.full_name,
          rut: agent.rut
        } : null
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Porcentaje Comisi\xF3n"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    currency: CurrencyTypes.PERCENTAGE,
    defaultValue: poliza.broker_information.commission_percentage,
    onValueChange: function onValueChange(value) {
      return onChangeItem({
        commission_percentage: formatValue(value, decimalFormat.decimalLimit)
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Comisi\xF3n Agente"), /*#__PURE__*/React.createElement(CurrencyInput, {
    className: "form-control",
    currency: currencyFormat.currency,
    value: poliza.broker_information.agent_commission,
    disabled: true
  }))))));
};

export default BrokerInformation;